export default __webpack_public_path__ + "static/gilroy-regular-3d1e1824653d48e7dd68a15376a51710.ttf";